import { TestDefinition, QuestionType } from '../../types';

// Escala 0-4 para Y-BOCS
const ybocsScale = [
  { label: '0 - Ninguno', value: 0 },
  { label: '1 - Leve', value: 1 },
  { label: '2 - Moderado', value: 2 },
  { label: '3 - Grave', value: 3 },
  { label: '4 - Extremo', value: 4 }
];

export const TESTS_TOC: TestDefinition[] = [
  {
    id: 'ybocs',
    code: 'Y-BOCS',
    name: 'Yale-Brown Obsessive Compulsive Scale',
    category: 'TOC',
    description: 'Escala de 10 ítems para evaluar severidad de síntomas obsesivo-compulsivos. Desarrollada por Goodman et al. (1989). Evalúa 5 dimensiones de obsesiones y 5 de compulsiones: tiempo, interferencia, malestar, resistencia y control.',
    questions: [
      // OBSESIONES (5 ítems)
      {
        id: 'o1',
        text: '1. Tiempo ocupado por pensamientos obsesivos',
        type: QuestionType.LIKERT,
        options: ybocsScale,
        subscale: 'Obsesiones'
      },
      {
        id: 'o2',
        text: '2. Interferencia debida a pensamientos obsesivos',
        type: QuestionType.LIKERT,
        options: ybocsScale,
        subscale: 'Obsesiones'
      },
      {
        id: 'o3',
        text: '3. Malestar asociado con los pensamientos obsesivos',
        type: QuestionType.LIKERT,
        options: ybocsScale,
        subscale: 'Obsesiones'
      },
      {
        id: 'o4',
        text: '4. Resistencia contra las obsesiones',
        type: QuestionType.LIKERT,
        options: ybocsScale,
        subscale: 'Obsesiones'
      },
      {
        id: 'o5',
        text: '5. Grado de control sobre los pensamientos obsesivos',
        type: QuestionType.LIKERT,
        options: ybocsScale,
        subscale: 'Obsesiones'
      },

      // COMPULSIONES (5 ítems)
      {
        id: 'c1',
        text: '6. Tiempo dedicado a realizar conductas compulsivas',
        type: QuestionType.LIKERT,
        options: ybocsScale,
        subscale: 'Compulsiones'
      },
      {
        id: 'c2',
        text: '7. Interferencia debida a las conductas compulsivas',
        type: QuestionType.LIKERT,
        options: ybocsScale,
        subscale: 'Compulsiones'
      },
      {
        id: 'c3',
        text: '8. Malestar asociado con la conducta compulsiva',
        type: QuestionType.LIKERT,
        options: ybocsScale,
        subscale: 'Compulsiones'
      },
      {
        id: 'c4',
        text: '9. Resistencia contra las compulsiones',
        type: QuestionType.LIKERT,
        options: ybocsScale,
        subscale: 'Compulsiones'
      },
      {
        id: 'c5',
        text: '10. Grado de control sobre las conductas compulsivas',
        type: QuestionType.LIKERT,
        options: ybocsScale,
        subscale: 'Compulsiones'
      }
    ],
    subscales: [
      {
        name: 'Obsesiones',
        questionIds: ['o1', 'o2', 'o3', 'o4', 'o5'],
        description: 'Tiempo, interferencia, malestar, resistencia y control de pensamientos obsesivos'
      },
      {
        name: 'Compulsiones',
        questionIds: ['c1', 'c2', 'c3', 'c4', 'c5'],
        description: 'Tiempo, interferencia, malestar, resistencia y control de conductas compulsivas'
      }
    ],
    interpretations: [
      { min: 0, max: 7, label: 'Subclínico', color: 'bg-green-100 text-green-800' },
      { min: 8, max: 15, label: 'TOC Leve', color: 'bg-yellow-100 text-yellow-800' },
      { min: 16, max: 23, label: 'TOC Moderado', color: 'bg-orange-100 text-orange-800' },
      { min: 24, max: 31, label: 'TOC Severo', color: 'bg-red-100 text-red-800' },
      { min: 32, max: 40, label: 'TOC Extremo', color: 'bg-red-200 text-red-900' }
    ]
  }
];
